import { postAnaliticsEvent } from "@/api/Api";
import { __DEV__ } from "./constants";
import { store } from "../redux/store";
import { AUTH_METHOD } from "./enums";
import { AnalyticsEvent, EventLog } from "./types";
import { getStoredTrackingParams } from "../analytics/urlParams";
import { getGaSessionId } from "../analytics/ga4";

const APP_VERSION = import.meta.env.VITE_APP_VERSION || "0.1.0";



const getOsInfo = (): { device_type: string; os_version: string } => {
    const ua = navigator.userAgent;
    if (ua.includes("Windows")) return { device_type: "Windows", os_version: ua.match(/Windows NT ([\d.]+)/)?.[1] || "" };
    if (ua.includes("Mac OS")) return { device_type: "Mac", os_version: ua.match(/Mac OS X ([\d_.]+)/)?.[1]?.replace(/_/g, ".") || "" };
    if (ua.includes("Linux")) return { device_type: "Linux", os_version: "" };
    return { device_type: "Unknown", os_version: "" };
};

export const getTwoHoursFromNow = (): string =>
    new Date(Date.now() + 2 * 60 * 60 * 1000).toISOString();

export const logPfsAnalyticsEvent = async (event: EventLog) => {
    try {
        const rawFailureReason = event.failure_reason;
        const failureReasonStr =
            rawFailureReason === undefined || rawFailureReason === null
                ? "{}"
                : typeof rawFailureReason === "object"
                    ? JSON.stringify(rawFailureReason)
                    : String(rawFailureReason) === "[object Object]"
                        ? "{}"
                        : String(rawFailureReason);

        const { device_type, os_version } = getOsInfo();
        const state = store.getState();
        const trackingParams = getStoredTrackingParams();

        const body: AnalyticsEvent = {
            general: {
                event_name: event.event_name,
                event_screen: event.event_screen,
                status: event.status || "",
                failure_reason: failureReasonStr,
                event_timestamp: new Date().toISOString(),
                app_version: APP_VERSION,
                device_type,
                os_version,
                business_unit: "pcil",
                user_platform: "web",
                channel: "TS",
                app_session_id: state.app.sessionId || "",
                ip: state.app.userIp || "",
                customer_id_encrypted: state.app.customerIdEncrypted || "",
                utm_source: trackingParams?.utm_source || "",
                utm_medium: trackingParams?.utm_medium || "",
                utm_campaign: trackingParams?.utm_campaign || "",
                variation: trackingParams?.variation || "",
                ga_session_id: getGaSessionId(),
                user_token: state.app.userToken || "",
            },
            ...(event.auth && { auth: event.auth }),
            ...(event.affiliate && { affiliate: event.affiliate }),
            ...(event.flight && { flight: event.flight }),
            ...(event.flight_supplier && { flight_supplier: event.flight_supplier }),
            ...(event.link && { link: event.link }),
        };

        // __DEV__ && console.log("================================================");
        // __DEV__ && console.log("[helpers] logPfsAnalyticsEvent == > ", body);
        // __DEV__ && console.log("================================================");

        postAnaliticsEvent({ feEvent: body });
    } catch (error) {
        __DEV__ && console.error("[helpers] Error logging analytics event:", error);
    }
};
